import { createEventBus } from "@core/features/eventBus";

export type ProgramEvents = {
  "program:circleModal:open": {
    programId: number;
    circleId: number;
  };

  "program:addToCalendarModal:open": {
    programId: number;
    circleId: number;
  };

  "program:addToCalendarModal:addCalendarEvent": {
    programId: number;
    circleId: number;
    meetingId: number | "all";
    calendarType: "google" | "ical";
  };
};

export const programEventBus = createEventBus<ProgramEvents>();

export default ProgramEvents;

